export const GET_ROOT_LIST = 'GET_ROOT_LIST'
export const GET_ORG_LIST = 'GET_ORG_LIST'
export const GET_NODE_LIST = 'GET_NODE_LIST'
export const GET_USER_LIST = 'GET_USER_LIST'
